import { Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { City } from 'src/typings';
import { CityService } from '../city.service';
import { CreateComponent } from '../create/create.component';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent {
  columnsToDisplay = ['city', 'menu'];

  control = new UntypedFormControl();

  cities: City[] = [];

  constructor(private cityService: CityService, private dialog: MatDialog) {
    this.searchCities();
  }

  async searchCities() {
    const res = await firstValueFrom(
      this.cityService.search({
        description: this.control.value || undefined
      })
    );
    this.cities = res.data;
  }

  async removeCity(city: City) {
    await this.cityService.delete(city.id).toPromise();
    this.searchCities();
  }

  addCity() {
    const dialogRef = this.dialog.open(CreateComponent);
    dialogRef.componentInstance.doneEvent.subscribe(() => {
      dialogRef.close();
      this.searchCities();
    });
  }

  updateCity(city: City) {
    const dialogRef = this.dialog.open(CreateComponent);
    dialogRef.componentInstance.city = city;
    dialogRef.componentInstance.doneEvent.subscribe(() => {
      dialogRef.close();
      this.searchCities();
    });
  }
}
